import React, { useEffect, useState } from 'react';
import { Form, Input, Collapse, Button, Space, InputNumber, Select, Checkbox } from 'antd';
import { FaTrash } from '@react-icons/all-files/fa/FaTrash'
import { MONTHS_OPTIONS, YEARS_OPTIONS } from '../../constants';
const {Panel} = Collapse;
export default props => {
    const {form} = props;
    return (        
            <>
            <div className="description">
                Showcase your educational background from the past decade. Mention your qualifications, certifications, and any pertinent academic achievements or specialized training.
            </div>
            <Form.List name="education">
                {(fields, { add, remove }) => (
                    <>  
                        {fields.map(({ key, name, fieldKey, ...restField }) => {

                            let educationObj = form.getFieldValue('education')
                            educationObj = educationObj[key]

                            const educationName = form.getFieldValue(['education', name, 'universityName']) || `Education ${name + 1}`;
                            
                            return (
                                <Collapse className="skills-collapse">
                                    <Panel key={`skill-${key}`} align="baseline" className="skill-item" header={(<div className="skill-item-header">
                                        <div className="left">
                                            {educationName}
                                        </div>
                                        <div className="right" >
                                            <FaTrash onClick={() => remove(key)} style={{ cursor: 'pointer' }} />
                                        </div>
                                    </div>)}>
                                        <div className="row">
                                            <Form.Item {...restField} name={[name, 'universityName']} label="University Name">
                                                <Input placeholder="Enter university name" />
                                            </Form.Item>
                                            <Form.Item {...restField} name={[name, 'degreeName']} label="Degree Name">
                                                <Input placeholder="Enter degree name" />
                                            </Form.Item>
                                        </div>
                                        <div className="row">
                                            <Form.Item {...restField} name={[name, 'courseName']} label="Course Name">
                                                <Input placeholder="Enter course name" />
                                            </Form.Item>
                                        </div>
                                        <div className="row">
                                            {/* Start Date */}
                                            <Form.Item label="Start Date" className="start-date">
                                                <div className="row">
                                                    <Form.Item {...restField} name={[name, 'startDate', 'month']} >
                                                        <Select placeholder="Month" options={MONTHS_OPTIONS} />
                                                    </Form.Item>
                                                    <Form.Item {...restField} name={[name, 'startDate', 'year']}>
                                                        <Select placeholder="Year" options={YEARS_OPTIONS} />
                                                    </Form.Item>
                                                </div>
                                            </Form.Item>

                                            {/* End Date */}
                                            <Form.Item label="End Date" className="end-date">
                                                <div className="row">
                                                    <Form.Item {...restField} name={[name, 'endDate', 'month']} >
                                                        <Select placeholder="Month" options={MONTHS_OPTIONS} disabled={educationObj?.isPresent} />
                                                    </Form.Item>
                                                    <Form.Item {...restField} name={[name, 'endDate', 'year']} >
                                                        <Select placeholder="Year" options={YEARS_OPTIONS} disabled={educationObj?.isPresent} />
                                                    </Form.Item>
                                                </div>
                                                <Form.Item {...restField} name={[name, 'isPresent']} valuePropName="checked">
                                                    <Checkbox >I still work here</Checkbox>
                                                </Form.Item>


                                            </Form.Item>
                                        </div>

                                    </Panel>
                                </Collapse>
                            )
                        }
                        )}
                        <Button type="dashed" onClick={() => add()} block>
                            Add Education
                        </Button>
                    </>
                )

                }
            </Form.List>
            </>

    )
}